import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ClipLoader } from "react-spinners";
import { Button } from "zina-dogi-react";
import { Formik, Form, Field } from "formik";
import { Row, Table } from "reactstrap";
import { utils } from "~/utils";
import swal from "sweetalert";

class PoAmendmentModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            isLoadig: false,
            disabled: false,
        };
    }

    close = () => {
        const initialState = {
            modal: false,
            isLoadig: false,
            disabled: false,
        }
        const last_state = {};
        Object.keys(this.state).forEach((item) => {
            if (!isNaN(item)){
                last_state[item] = false
            }
        })
        this.setState({...initialState, ...last_state})
    };

    open = () => {
        this.setState({
            modal: true,
        });
    };

    toggle = () => {
        const modal = !this.state.modal;
        if (modal) {
            this.open();
        } else {
            this.close();
        }
    };
    

    handleClick = (name, clicked, formik, v) => {
        if(!clicked){
            if(name === 'quantity_checkbox'){
                Object.keys(v).forEach((key)=> {
                    if(key.includes('qty')){
                        formik.setFieldValue(key, '', false)
                    }
                })
            }else{
                if(name === 'unit_price_checkbox'){
                    Object.keys(v).forEach((key)=> {
                        if(key.includes('net_price')){
                            formik.setFieldValue(key, '', false)
                        }
                    })
            }
        }
    }
}
    onSubmit = (values, formik) => {
        const { runID, path } = this.props
        let final_values = {}
        Object.keys(values).forEach(key => {
            if((key.includes('_qty') || key.includes('_net_price')) && (values[key] !== "")){
                final_values[key] = values[key]
            }
        })
        if(Object.keys(values).length === 0){
            swal({
                title: "Error",
                text: `Please select an item to perform this action`,
                icon: "error",
                timer: 5000,
                button: true
            });
            return 
          }
        swal({
            title: "PO amendment",
            text: `Are you sure to continue?. This operation is not reversible.`,
            icon: "warning",
            buttons: {
                amend: "Amend",
                close: "Close"
            }
            }).then(willAmend => {
                switch (willAmend) {
                    case "amend":
                        this.setState({ isLoadig: true });
                        this.props
                            .onSubmit(runID, final_values, path)
                            .then((results) => {
                                this.setState({ isLoadig: false });
                                formik.setSubmitting(false);
                                this.toggle();
                                swal({
                                    title: results.detail ? "Success" : "Error",
                                    text: results.detail ? results.detail : utils.computeError(results),
                                    icon: results.detail ? "success" : "error",
                                    button: true
                                });
                                
                            })
                            .catch(error => {
                                this.setState({ isLoadig: false });
                                swal({
                                    title: "Error!",
                                    text: utils.computeError(error),
                                    icon: "error",
                                    button: true
                                });
                            });
                        break;
                    default:
                        break;
                }
            });
        
    }

    validateGeneral = (checked, value, s_value) => {
        let error;
        if (checked && !value && !s_value) {
            error = "This field is required";
        }
        return error;
    };

    validateCheckboxSelected = (f_value, s_value) => {
        let error;
        if(f_value && s_value){
            error = "Select just one checkbox"
        }
        return error
    }

    renderError = (formik, type) => {
        if (formik.errors.hasOwnProperty(type) && formik.errors[type]) {
            return <small className="text-danger form-text">{formik.errors[type]}</small>;
        }
        return null;
    };

    // ADDED TO AVOID CHOOSING MORE THAN ONE ITEM
    getData = (oet_ssoti, run, oet) => {
        let res = [];
        if (oet_ssoti && oet_ssoti.length > 0) {
            oet_ssoti.map(item => {
                const omc = item.item_omc;
                if (omc) {
                    omc.omc_id = omc.id;
                    delete omc.id;
                }
                const father = {
                    ...item,
                    material_code: item.cost_package.code,
                    voa_case: item.voa_case ? item.voa_case.name : null,
                    description: item.cost_package.name,
                    sap_wbs_region_description: item.site ? item.site.sap_wbs_region_description : null,
                    customer_site_code: item.site ? item.site.customer_site_code : null,
                    ...(omc ? omc : {}),
                    synergy: item.synergy !== null ? (item.synergy ? "Synergy Partner" : "Non Synergy Partner") : null,
                    father: true,
                    wbs_or_contract: oet.quantity_contract_number ? oet.quantity_contract_number : item.sap_wbs_zone_description,
                    sales_office: oet.sales_office,
                    profit_center: run.profit_center,
                };
                delete father.site_service_order_template_item;
                if (item.ssot_items_cpm && item.ssot_items_cpm.length > 0) {
                    item.ssot_items_cpm.map(ssot_item_cpm => {
                        ssot_item_cpm.cmp_id = ssot_item_cpm.id;
                        delete ssot_item_cpm.cmp_id;
                        const obj = {
                            ...father,
                            father: false,
                            ...ssot_item_cpm,
                            row_line_number_qc: father.row_line_number_qc,
                            material_code: ssot_item_cpm.cost_package_sales_item.sales_item_code,
                            description: ssot_item_cpm.cost_package_sales_item.description,
                            svo_text: ssot_item_cpm.svo_text,
                            svo_number: ssot_item_cpm.svo_number,
                            quantity: item.quantity
                        };
                        res.push(obj);
                        return [];
                    });
                }
                return [];
            });
        }
        res = res.length === 0 ? [{}] : res;
        return res;
    };
    
    handleCheckboxDisable= (checked, sap_item, formik)=>{
        if(checked === true){
            this.setState({ [sap_item]: checked, disabled: true })
        }else{
            this.setState({[sap_item]: checked, disabled: false})
            formik.setFieldValue(sap_item +'_qty', '', false)
            formik.setFieldValue(sap_item +'_net_price', '', false)
        }
    }

    checkDisable = (sap_item)=> {
        if(this.state[sap_item] && this.state[sap_item] === true){
            return false
        }else if(!(this.state[sap_item] in this.state) && this.state.disabled === false){
            return false
        }else{
            return true
        }
    } 
    
    render() {
        const { className, buttonLabel } = this.props;
        const { modal } = this.state;
        const modalStyle = { width: "50%", maxWidth: "50%"};
        const data = this.getData(this.props.oet_ssoti, this.props.run, this.props.oet);
        return (
            <div>
                {buttonLabel && (
                    <Button color="primary" onClick={this.toggle}>
                        {buttonLabel}
                    </Button>
                )}
                <Modal isOpen={modal} toggle={this.toggle} className={className} backdrop="static" style={modalStyle}>
                    <ModalHeader toggle={this.toggle}>{'PO amendment'}</ModalHeader>
                    <ModalBody>
                        <div>
                            {data.length === 1 && Object.keys(data[0]).length === 0 ?
                            <React.Fragment>
                                    <div>
                                        <ClipLoader />
                                    </div>
                                    Please wait for data...
                                </React.Fragment>
                                    :
                            <React.Fragment>
                                    <Formik 
                                        onSubmit={this.onSubmit}>
                                        {({ values:v, ...formik }) => (
                                                <Form className="form" id='form'>
                                                    <Table responsive bordered>
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th>Zina ID</th>
                                                                <th>
                                                                    <Field
                                                                        name='quantity_checkbox'
                                                                        type="checkbox"
                                                                        onClick={(event) => {this.handleClick('quantity_checkbox', event.target.checked, formik, v)} }
                                                                        validate={() => this.validateCheckboxSelected(v['quantity_checkbox'], v['unit_price_checkbox'])}
                                                                    />
                                                                    
                                                                    Quantity
                                                                    <label>
                                                                    {this.renderError(formik, 'quantity_checkbox')}

                                                                    </label>
                                                                </th>
                                                                <th>
                                                                    <Field
                                                                        name='unit_price_checkbox'
                                                                        type="checkbox"
                                                                        onClick={(event) => {this.handleClick('unit_price_checkbox', event.target.checked, formik, v)} }
                                                                        validate={() => this.validateCheckboxSelected(v['quantity_checkbox'], v['unit_price_checkbox'])}
                                                                    />
                                                                    Unit Price
                                                                    <label>
                                                                    {this.renderError(formik, 'unit_price_checkbox')}
                                                                    

                                                                    </label>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody >
                                                            {data.map((item, idx) => {
                                                                var sap_item = ((idx + 1)*10).toString()
                                                                const qty = sap_item + '_qty'
                                                                const net_price = sap_item + '_net_price'
                                                                return (
                                                                    <tr key={sap_item}>
                                                                        <th>
                                                                            <Field
                                                                                name={sap_item}
                                                                                type="checkbox"
                                                                                onClick={(event) => {this.handleCheckboxDisable(event.target.checked, sap_item, formik)} }
                                                                                disabled={this.checkDisable(sap_item)}
                                                                            />
                                                                        </th>
                                                                        <th>
                                                                            {item.id}
                                                                        </th>
                                                                        <th>
                                                                            <Field
                                                                                name={qty}
                                                                                type="text"
                                                                                placeholder={item.quantity}
                                                                                value={!v[sap_item] || !v['quantity_checkbox'] ? '' : v[qty] ? v[qty] : '' }
                                                                                disabled={!v[sap_item] || v[net_price] || !v['quantity_checkbox']}
                                                                                validate={() => this.validateGeneral(v[sap_item], v[qty], v[net_price])}
                                                                            />  
                                                                        {this.renderError(formik, sap_item + '_qty')}

                                                                        </th>
                                                                        <th>
                                                                            <Field
                                                                                name={net_price}
                                                                                type="text"
                                                                                placeholder={item.ssot_items_cpm[0].voa_item_net_price}
                                                                                value={!v[sap_item] || !v['unit_price_checkbox'] ? '' : v[net_price] ? v[net_price] : ''}
                                                                                disabled={!v[sap_item] || v[qty] || !v['unit_price_checkbox']}
                                                                                validate={() => this.validateGeneral(v[sap_item], v[net_price], v[qty])}
                                                                                />
                                                                                {this.renderError(formik, sap_item+'_net_price')}
                                                                        </th>
                                                                    </tr>
                                                                );
                                                            })
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Form>
                                        )}
                                    </Formik>
                            </React.Fragment>
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            {this.state.isLoadig && (
                                <ClipLoader />
                            )}
                            <Button
                                type="submit"
                                color="primary"
                                style={{ width: "150px" }}
                                className="mr-1"
                                form='form'
                            >
                                Send job
                            </Button>
                            <Button
                                className="btn-danger mr-1"
                                onClick={this.toggle}
                                type="button"
                                name="Close"
                                style={{ width: "150px" }}
                            >
                                Cancel
                            </Button>
                        </Row>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
    
    _cancel = () => {
        this.close();
    };
}

export default PoAmendmentModal;